/*=============================================== FadePage ===============================================*/

import { Link } from "react-router-dom"
import { Text } from "tsx-library-julseb"

import { ComponentsLayout } from "components"
import type { ItemType } from "components"

const FadePage = () => {
    const items: ItemType[] = [
        {
            content: (
                <Text>
                    <Link
                        to="/components/fade/demo"
                        target="_blank"
                        rel="noreferrer noopener"
                    >
                        Demo here.
                    </Link>
                </Text>
            ),
            code: "<Fade>\n    \n</Fade>",
        },
    ]

    return <ComponentsLayout items={items} propsItems={[]} />
}

export default FadePage
